import { useQuery } from '@tanstack/react-query';
import { Client } from 'src/admin/users/types';

export const useClient = (clientId: string | undefined) => {
  const { data, isLoading, error, refetch } = useQuery<Client>({
    queryKey: ['clients', clientId],
    enabled: !!clientId,
  });

  return {
    client: data ?? null,
    isLoading,
    error,
    refetch,
  };
};
